import { Map, List, fromJS } from 'immutable';
import {
  getDeliveryTermCs,
  getDeliveryTermFs,
  getDeliveryTermDs,
  getDeliveryTermUnion,
  getRegNumberText,
  composeAbbrev,
} from '../../../../util/util';
import { VERSIONS, CURRENT_RELEASE } from '@/util/version';
import { Currency } from '@/consts/currency';
import { formPaymentExpense, BULK_PAYMENT_TYPE } from '../payments/PaymentsContainer';
import store from '@/store/store';
// import { REF_PATH as EXPENSES_TYPE_REF_PATH }
//   from '@/component/dict/complex/expensestype/Const';
import { putPLRow } from '../store/pltab.store';
export const FREIGHT_EXPENSES_TYPE = 'freight';
export const INTEREST_EXPENSES_TYPE = 'interest';
export const PRODUCT_EXPENSES_TYPE = 'contract payment';
export const BANKING_EXPENSES_TYPE = 'banking';

// считам B/L по всем линкам, если хотя бы 1 не задан
function calcBLByAllLinks(links, changedLink = new List()) {
  let billLandingQuantity = 0;

  const modifiedLinks = links.map(l => (l.get('id') == changedLink.get('id') ? changedLink : l));
  if (modifiedLinks && modifiedLinks.size > 0) {
    // все ли B/L заполнены
    const blFilteredLinks = modifiedLinks.filter((l) => l.get('billLandingQuantity'));

    // калькулируем B/L
    if (modifiedLinks.size == blFilteredLinks.size) {
      blFilteredLinks.forEach((l) => {
        billLandingQuantity += l.get('billLandingQuantity') || 0;
      });
    }
  }

  return billLandingQuantity;
}

function getSPLinks(atom) {
  let links = new List();

  if (atom) {
    if (atom.get('purchaseLink') && atom.get('purchaseLink').size > 0) {
      links = atom.get('purchaseLink', new List()).filter((l) => !l.get('hidden'));
    }

    if (atom.get('saleLink') && atom.get('saleLink').size > 0) {
      links = atom.get('saleLink', new List()).filter((l) => !l.get('hidden'));
    }
  }

  return links;
}

function getTLinks(deal) {
  let links = new List();

  if (deal) {
    links = deal.get('links', new List()).filter((l) => !l.get('hidden'));
  }

  return links;
}

function divideBulkPayment(bulkPayments = new List(), link, transportId,
  transports = new List()) {
  let expenses = new List();
  bulkPayments.forEach(payment => {
    let linkedTransports = new List();
    payment.get('bulkPaymentTransports', new List()).forEach(bulkTrId => {
      linkedTransports = linkedTransports.push(transports.find(t => t.get('id') == bulkTrId));
    });
    let totalBL = 0;
    let blMissing = false;
    let thisTransportTotalBl = 0;
    linkedTransports.forEach(transport => {
      const links = getTLinks(transport);
      const bl = calcBLByAllLinks(links);
      if (transportId != undefined && transportId == transport.get('id')) {
        thisTransportTotalBl += bl;
      }
      if (bl) {
        totalBL += bl;
      } else {
        blMissing = true;
      }
    });
    const dueAmountPercent = transportId == undefined ? link.get('billLandingQuantity') / totalBL :
      thisTransportTotalBl / totalBL;
    let expense = fromJS(formPaymentExpense(payment, undefined));
    if (!blMissing && totalBL &&
      ((link && link.get('billLandingQuantity')) || thisTransportTotalBl)) {
      expense = expense.set('actual', expense.get('actual', 0) * dueAmountPercent);
    } else {
      expense = expense.set('isBulkExpenseWithoutBL', true);
    }
    const existingExpenseIdx = expenses.findIndex(e =>
      e.get('expensesType') == expense.get('expensesType'));
    if (existingExpenseIdx > -1) {
      const actualValue = expenses.get(existingExpenseIdx).get('actual')
        + (expense.get('isDebit') ? expense.get('actual') : -expense.get('actual'));
      expenses = expenses.set(existingExpenseIdx,
        expenses.get(existingExpenseIdx).set('actual', actualValue));
    } else {
      expenses = expenses.push(
        expense.set('isBulkExpense', true)
          .set('actual', (expense.get('isDebit') ? expense.get('actual') : -expense.get('actual')))
      );
    }
  });
  expenses = expenses.map(e => (e.get('actual') < 0 ?
    e.set('isDebit', false).set('actual', Math.abs(e.get('actual')))
    : e.set('isDebit', true).set('actual', Math.abs(e.get('actual'))))
  );
  return expenses;
}
export function divideBulkPaymentForTransport(bulkPayments = new List(), transportId,
  transports = new List()) {
  return divideBulkPayment(bulkPayments, undefined, transportId, transports);
}
export function divideBulkPaymentForLink(bulkPayments = new List(), link,
  transports = new List()) {
  return divideBulkPayment(bulkPayments, link, undefined, transports);
}
export function filterBulkPayments(bulkPayments = new List(), dealType,
  expensestypes = new List(), linkTransportId) {
  const freightTypeId = expensestypes.find(e =>
    e.get('name').toLowerCase() == FREIGHT_EXPENSES_TYPE, this, new Map()).get('id');

  const filteredPayment = bulkPayments.filter(payment => {
    if (payment.get('isParentHidden') || payment.get('expensesType') == freightTypeId) {
      return false;
    }
    if (payment.get('bulkPaymentTransports') && payment.get('bulkPaymentTransports').size > 0) {
      if (payment.get('bulkPaymentType', BULK_PAYMENT_TYPE.sameType) ==
          BULK_PAYMENT_TYPE.sameType) {
        return payment.get('dealtype') == dealType;
      }
      return ((dealType == 'purchase' &&
          payment.get('bulkDischargeTransports').toJS().indexOf(linkTransportId) == -1)
              || (dealType == 'sale' &&
          payment.get('bulkDischargeTransports').toJS().indexOf(linkTransportId) > -1));
    }
    return false;
  });
  return filteredPayment;
}

export function getBulkPaymentFiles(documents = new List(), files = new List(), uniqUUIDs = []) {
  let newFiles = documents.map(f => {
    if (f && f.get && uniqUUIDs.indexOf(f.get('uuid')) == -1) {
      uniqUUIDs.push(f.get('uuid'));
      return f;
    }
    return undefined;
  })
    .filter(f => f);
  newFiles = files.concat(newFiles);

  newFiles = newFiles.map(f =>
    ({ file: {}, meta: f.set('isBulkExpenseFile', true).toJS() }));
  return newFiles;
}


function getBulkExpenses() {
  // const state = store.getState();
  // const transportsStore = state.getIn(['data', 'deals', 'list', 'transport']);
  // const expensestypesStore = state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH],
  //   new List());
  return new List();
  // if (dealType == 'transport') {
  //   const links = elem.get('links') ? elem.get('links') : undefined;
  //   if (links && transportsStore && expensestypesStore) {
  //     const bulkPayments = filterBulkPayments(elem.get('bulkPayments', new List()),
  //       dealType, expensestypesStore);
  //     if (bulkPayments.size > 0) {
  //       expenses = expenses.concat(divideBulkPaymentForTransport(bulkPayments, elem.get('id'),
  //         transportsStore));
  //     }
  //   }
  // } else {
  //   const links = elem.get(`${dealType}Link`) ? elem.get(`${dealType}Link`) : undefined;
  //   if (links && transportsStore && expensestypesStore) {
  //     links.forEach(l => {
  //       const transportId = l.get('transport');
  //       if (transportId != undefined && transportId != null && transportsStore) {
  //         const transport = transportsStore
  //           .find(t => t.get('id') == transportId, this, new Map());
  //         const bulkPayments = filterBulkPayments(transport.get('bulkPayments', new List()),
  //           dealType, expensestypesStore, transportId);
  //         if (bulkPayments.size > 0) {
  //           expenses = expenses.concat(divideBulkPaymentForLink(bulkPayments, l,
  //             transportsStore));
  //         }
  //       }
  //     });
  //   }
  // }
  // return expenses;
}

const enforceSingleFreight = (expenses) => {
  const isFreightExpense = exp => (exp.get('expensesTypeName') || '').toLowerCase() === FREIGHT_EXPENSES_TYPE;
  const freightExpense = expenses.find(exp => isFreightExpense(exp));
  if (freightExpense) {
    return expenses.filter(exp => !isFreightExpense(exp)).push(freightExpense);
  }
    return expenses;
}

const getExpenses = (elem, dealType) => (elem && elem.get('expenses') ?
  elem.get('expenses').concat(getBulkExpenses(elem, dealType)) : new List());
const getExpensesJS = (elem, dealType) => enforceSingleFreight(getExpenses(elem, dealType)).toJS();

function getValue(obj, name) {
  let value = undefined;
  if (typeof obj.get === 'function') {
    value = obj.get(name);
  } else {
    value = obj[name];
  }
  return value;
}

export function getCurrencyValue(elem,
  valueFieldName = 'priceValue',
  currencyFieldName = 'priceCurrency',
  currencyRatesFieldName = 'priceCurrencyRates') {
  if (!elem) {
    return 0;
  }
  const price = getValue(elem, valueFieldName) || 0.0;
  const currency = getValue(elem, currencyFieldName) || Currency.DOLLAR;
  if (currency != Currency.DOLLAR) {
    let currencyRates = getValue(elem, currencyRatesFieldName) || new List();
    if (!Array.isArray(currencyRates)) {
      currencyRates = currencyRates.toJS();
    }
    const currencyRate = currencyRates.find(r => r.value == currency);
    if (currencyRate && currencyRate.rate) {
      return price * currencyRate.rate;
    }
    const state = store.getState();
    const todayRates = state.getIn(['data', 'currencies', Currency.DOLLAR, 'rates'], new List());
    const todayRate = todayRates.find(r => r.get('currency') == currency);
    if (todayRate) {
      return todayRate.get('rate', 0) * price;
    }

    return 0;
  }
  return price;
}

export function getPriceValue(elem) {
  return getCurrencyValue(elem, 'priceValue', 'priceCurrency', 'priceCurrencyRates');
}

function getFreightValue(elem) {
  return getCurrencyValue(elem, 'freightAmount', 'freightCurrency', 'freightCurrencyRates');
}

function getEstimatedExpenseValue(elem) {
  return getCurrencyValue(elem, 'estimate', 'estimateCurrency', 'estimateCurrencyRates');
}

function getActualExpenseValue(elem) {
  const result = getCurrencyValue(elem, 'actualWithBulk',
    'estimateCurrency', 'estimateCurrencyRates');
  if (!result) {
    return getCurrencyValue(elem, 'actual', 'estimateCurrency', 'estimateCurrencyRates');
  }
  return result;
}

export function getNumeric(value) {
  return value == null || value == '' || isNaN(value) ? 0.0 : parseFloat(value);
}

function validateLinkedDeal(link, valueName, dealType) {
  if (valueName == 'purchaseId') {
    return (dealType == 'purchase') || (dealType != 'purchase' && link.get('purchaseId') > 0);
  }
  if (valueName == 'saleId') {
    return (dealType == 'sale') || (dealType != 'sale' && link.get('saleId') > 0);
  }
  if (valueName == 'transport') {
    return (dealType == 'transport') || (dealType != 'transport' && link.get('transport') > 0);
  }
  return false;
}


function filterLinks(links, dealType) {
  if (links && links.size > 0) {
    return links.filter((l) =>
      validateLinkedDeal(l, 'purchaseId', dealType) &&
      validateLinkedDeal(l, 'saleId', dealType));
  }
  return links;
}

function filterFullLinks(links, dealType) {
  if (links && links.size > 0) {
    return links.filter((l) =>
      validateLinkedDeal(l, 'purchaseId', dealType)
      && validateLinkedDeal(l, 'saleId', dealType)
      && validateLinkedDeal(l, 'transport', dealType));
  }
  return links;
}

function getFailedLinks(links = new List()
  // ,dealType
) {
  // берем только слинкованные сделки
  // const linkedLinks = filterLinks(links, dealType);
  // линки без установленных B/L
  return links.filter((l) => !l.get('billLandingQuantity'));
}

// считаем только полные линки (P-T-S + B/L quantity)
// undefined не возвращаем, т.к. есть отдельный алгоритм проверки
function calcBLByFullLinks(links, dealType) {
  let billLandingQuantity = 0;

  if (links && links.size > 0) {
    // берем только слинкованные сделки
    const linkedLinks = links.filter((l) =>
      validateLinkedDeal(l, 'purchaseId', dealType)
      && validateLinkedDeal(l, 'saleId', dealType));

    // все ли B/L заполнены
    const blFilteredLinks = linkedLinks.filter((l) => l.get('billLandingQuantity'));

    // калькулируем B/L
    blFilteredLinks.forEach((l) => {
      billLandingQuantity += l.get('billLandingQuantity') || 0;
    });
  }

  return billLandingQuantity;
}

// eslint-disable-next-line
function filterProperLinks(data, dataType, linksToValidate) {
  // новый отфильтрованный список
  let filteredLinks = new List();

  // ссылки
  const links =
    dataType == 'transport'
      ? getTLinks(data)
      : getSPLinks(data);

  if (linksToValidate) {
    // откидываем уже проверенные линки по id-ку
    filteredLinks = linksToValidate.filter((lv) => {
      const filtered = links.filter((l) => l.get('id') == lv.get('id'));
      return !(filtered.size > 0);
    });
  }

  return filteredLinks;
}

export function calcAtomBLCountByAllLinks(atom, changedLink) {
  return calcBLByAllLinks(getSPLinks(atom), changedLink);
}

export function calcTransportBLCountByAllLinks(transport) {
  return calcBLByAllLinks(getTLinks(transport));
}

export function calcAtomBLCountByFullLinks(atom, dealType) {
  return calcBLByFullLinks(getSPLinks(atom), dealType);
}

export function calcTransportBLCountByFullLinks(transport, dealType) {
  return calcBLByFullLinks(getTLinks(transport), dealType);
}

export function calcPerTon(actual, billLandingQuantity) {
  if (!billLandingQuantity || billLandingQuantity == 0) {
    return 0;
  }
  return (actual || 0) / billLandingQuantity;
}

export function calcActual(expensesArg, billLandingQuantity, elementId, groupId, link) {
  const expenses = expensesArg && expensesArg.get ? expensesArg.toJS() : expensesArg;
  let actual = 0.0;
  if (expenses && billLandingQuantity != undefined) {
    expenses.forEach((exp) => {
      let value = 0;
      if (exp.summType == 'LS') {
        value = calcPerTon(getActualExpenseValue(exp), billLandingQuantity);
      } else {
        value = getNumeric(getActualExpenseValue(exp));
      }
      if (exp.isDebit) {
        actual += value;
      } else {
        actual -= value;
      }
      let estimatedPt = getNumeric(getEstimatedExpenseValue(exp));
      if (groupId && elementId && (value || estimatedPt) && (exp.id || exp.autoCreated)) {
        const bl = link ? link.get('billLandingQuantity') : billLandingQuantity;
        if ((exp.expensesTypeName || '').toLowerCase() == FREIGHT_EXPENSES_TYPE && !estimatedPt) {
          estimatedPt = value;
        }
        putPLRow(store.dispatch, `${exp.expensesTypeName}#${exp.id}`,
          { pt: value * (exp.isDebit ? -1 : 1),
            bl,
            estimatedPt: estimatedPt * (exp.isDebit ? -1 : 1) },
          elementId, groupId);
      }
    });
  }
  return actual.toFixed(2);
}

export function calcEstimated(expenses, elementId, groupId) {
  let estimated = 0.0;
  if (expenses) {
    expenses.forEach((exp) => {
      const value = getNumeric(getEstimatedExpenseValue(exp));
      if (exp.isDebit) {
        estimated += value;
      } else {
        estimated -= value;
      }
      if (exp && exp.expensesTypeName &&
        exp.expensesTypeName.toLowerCase() == FREIGHT_EXPENSES_TYPE) {
        if (exp.estimate && groupId) {
          putPLRow(store.dispatch, 'Transport freight#',
            { estimatedPt: exp.estimate * -1 },
            elementId, [groupId[0], 'transport']);
        }
      }
    });
  }
  return estimated.toFixed(2);
}

function validateFreightNecessity(leftAtomDT, rightAtomDt) {
  // если не заданы, то freight не нужен
  if (!leftAtomDT || !rightAtomDt) {
    return false;
  }

  // наборы значений для логики
  const caseOne = getDeliveryTermCs();
  const caseTwo = getDeliveryTermFs();
  const caseThree = getDeliveryTermDs();
  const caseFour = getDeliveryTermUnion();

  let isFreightExpenseNecessary = true;

  if (caseOne.has(leftAtomDT.get('name'))
    && caseOne.has(rightAtomDt.get('name'))) {
    isFreightExpenseNecessary = false;
  }
  if (caseTwo.has(leftAtomDT.get('name'))
    && caseTwo.has(rightAtomDt.get('name'))) {
    isFreightExpenseNecessary = false;
  }
  if (caseThree.has(leftAtomDT.get('name'))
    && caseThree.has(rightAtomDt.get('name'))) {
    isFreightExpenseNecessary = false;
  }
  if (caseThree.has(leftAtomDT.get('name'))
    && caseTwo.has(rightAtomDt.get('name'))) {
    isFreightExpenseNecessary = false;
  }
  if (leftAtomDT.get('name') == 'CPT' && rightAtomDt.get('name') == 'FOB') {
    isFreightExpenseNecessary = false;
  }
  if (leftAtomDT.get('name') == 'CIF' && rightAtomDt.get('name') == 'FOB') {
    isFreightExpenseNecessary = false;
  }
  if (leftAtomDT.get('name') == 'FCA' && rightAtomDt.get('name') == 'CPT') {
      isFreightExpenseNecessary = false;
    }
  if (leftAtomDT.get('name') == rightAtomDt.get('name')
    && !caseFour.has(leftAtomDT.get('name'))
    && !caseFour.has(rightAtomDt.get('name'))) {
    isFreightExpenseNecessary = false;
  }

  return isFreightExpenseNecessary;
}

function linksValidatedForFreightProcessing(
  links,
  atom,
  dealType,
  deals,
  deliveryTerms,
  callbackOkFunc,
  callbackActualErrFunc,
  callbackEstimatedErrFunc) {
  if (atom && dealType
    && links && links.size > 0
    && deals && deals.size > 0
    && deliveryTerms && deliveryTerms.size > 0) {
    //
    links.forEach((link) => {
      // атом "слева" для сверки
      let leftAtom = undefined;

      // DT "слева" для сверки
      let leftAtomDT = undefined;

      const leftDealType = dealType == 'transport' ? 'purchase' : dealType;

      if (dealType == 'transport') {
        const leftDealId = leftDealType == 'purchase'
          ? link.get('purchaseId')
          : link.get('saleId');

        const leftProductId = leftDealType == 'purchase'
          ? link.get('purchaseProduct')
          : link.get('saleProduct');

        // транспорт, потому сделки всегда сохранены
        const leftDeal = deals
          .get(leftDealType, new List())
          .find(d => d.get('id') == leftDealId);

        if (leftDeal) {
          leftAtom = leftDeal
            .get('products', new List())
            .find(p => p.get('id') == leftProductId);

          leftAtomDT = deliveryTerms
            .find(dt => dt.get('id') == leftAtom.get('deliveryTerm'));
        }
        // elseif
      } else {
        leftAtom = atom;
        leftAtomDT = deliveryTerms
          .find(dt => dt.get('id') == atom.get('deliveryTerm'));
      }

      // атом справа для сверки
      const rightDealType = leftDealType == 'purchase' ? 'sale' : 'purchase';

      const rightDealId = rightDealType == 'purchase'
        ? link.get('purchaseId')
        : link.get('saleId');

      const rightProductId = rightDealType == 'purchase'
        ? link.get('purchaseProduct')
        : link.get('saleProduct');

      const rightDeal = deals
        .get(rightDealType, new List())
        .find(d => d.get('id') == rightDealId);

      if (rightDeal) {
        const rightAtom = rightDeal
          .get('products', new List())
          .find(p => p.get('id') == rightProductId);

        const rightAtomDt = deliveryTerms
          .find(dt => dt.get('id') == rightAtom.get('deliveryTerm'));

        if (leftAtom && rightAtom) {
          // получаем транспорт, если он есть
          let transport = undefined;

          if (dealType == 'transport') {
            transport = atom;
          } else {
            transport = deals
              .get('transport', new List())
              .find(t => t.get('id') == link.get('transport'));
          }

          // определяем необходимость Freight
          let isFreightExpenseNecessary = true;
          if (leftDealType == 'purchase') {
            isFreightExpenseNecessary = validateFreightNecessity(leftAtomDT, rightAtomDt);
          } else {
            isFreightExpenseNecessary = validateFreightNecessity(rightAtomDt, leftAtomDT);
          }

          if (isFreightExpenseNecessary) {
            let isEstimatedFreightDefined = false;
            // actual - затрата берется с транспорта
            if (transport) {
              // смотрим затраты транспорта на наличие Freight
              const transportFreight = getFreightValue(transport) || 0.0;

              if (transportFreight <= 0.0) {
                // freight не задан
                if (callbackActualErrFunc) {
                  callbackActualErrFunc(link, transport, leftAtom, rightAtom);
                }
              }
            } else {
              // транспорт не задан, хотя должен присуствовать
              if (callbackActualErrFunc) {
                callbackActualErrFunc(link, transport, leftAtom, rightAtom);
              }
            }

            // берем sale
            const saleAtom = leftDealType == 'sale' ? leftAtom : rightAtom;

            // estimated - затрата берется с Sale
            if (saleAtom) {
              const freight = getExpenses(saleAtom, 'sale')
                .filter((e) => {
                  const name = getValue(e, 'expensesTypeName');
                  return (name || '').toLowerCase() == FREIGHT_EXPENSES_TYPE;
                });
              let finalFreight;
              if (freight && freight.size > 0) {
                finalFreight = getValue(freight.get(0), 'estimate');
              }
              if (!finalFreight) {
                finalFreight = getFreightValue(transport) || 0.0;
              }
              if (finalFreight > 0) {
                // freight задан
                isEstimatedFreightDefined = true;
              } else {
                // freight не задан
                if (callbackEstimatedErrFunc) {
                  callbackEstimatedErrFunc(link, transport, leftAtom, rightAtom);
                }
              }
            }
            // Согласно постановке, если для линковок в Sale не указана затрата Estimated Freight,
            // то такие линковки не должны попадать в расчет Estimated profitability.
            if (isEstimatedFreightDefined) {
              // freight задан как минимум для одного случая
              // (если что, можно будет 2 обратных вызова написать, вместо 1-го общего)
              if (callbackOkFunc) {
                callbackOkFunc(link, transport, leftAtom, rightAtom);
              }
            }
          } else {
            // freight не обязателен
            if (callbackOkFunc) {
              callbackOkFunc(link, transport, leftAtom, rightAtom);
            }
          }
        }
      }
    });
  }
}

function getQuantity(data) {
  let quantity = 0.0;
  if (data.get('quantityMin')
    && data.get('quantityMax')) {
    quantity = (parseFloat(data.get('quantityMin') || 0.0)
      + parseFloat(data.get('quantityMax') || 0.0)) / 2.0;
  } else {
    quantity = (data.get('quantity') || 0.0);
  }
  return Number.parseFloat(quantity);
}

export function calcEstimatedAtomQuantityCount(atom, dealType, deals, deliveryTerms) {
  let quantity = 0;
  linksValidatedForFreightProcessing(
    getSPLinks(atom),
    atom,
    dealType,
    deals,
    deliveryTerms,
    (link) => {
      quantity += link.get('billLandingQuantity') || getQuantity(link);
    }
  );
  return quantity;
}

function validateLinks(dealType,
  deal,
  links,
  deals,
  buyers,
  suppliers,
  dealErrors) {
  const errors = [];

  if (links && links.size > 0
  && deals && deals.size > 0
  && buyers && buyers.size > 0
  && suppliers && suppliers.size > 0) {
    const linksWithoutBLs = getFailedLinks(links, dealType);

    linksWithoutBLs.forEach(l => {
      // id-ки S и P
      const saleId = l.get('saleId');
      const purchaseId = l.get('purchaseId');

      let sale = undefined;
      let purchase = undefined;

      if (dealType == 'sale' && deal) {
        sale = deal;
      } else {
        sale = deals.get('sale', new List()).find(s => s.get('id') == saleId);
      }
      if (dealType == 'purchase' && deal) {
        purchase = deal;
      } else {
        purchase = deals.get('purchase', new List()).find(p => p.get('id') == purchaseId);
      }
      let purchaseName = '';
      let saleName = '';
      // название S и P
      if (sale) {
        const buyer = buyers.find((b) => b.get('id') == sale.get('buyer'));
        saleName =
        getRegNumberText(
          sale,
          'S',
          composeAbbrev(buyer ? buyer.get('name') : undefined),
          'regNumber',
          'Sale'
        );
      }
      if (purchase) {
        const supplier = suppliers.find((b) => b.get('id') == purchase.get('supplier'));
        purchaseName =
          getRegNumberText(
            purchase,
            'P',
            composeAbbrev(supplier ? supplier.get('name') : undefined),
            'regNumber',
            'Purchase'
          );
      }
      const errorMessage = `${purchaseName} : ${saleName}`;

      let isNewError = true;

      // проверяем по внешнему списку ошибок
      if (dealErrors) {
        dealErrors.forEach((err) => {
          if (err == errorMessage) {
            isNewError = false;
          }
        });
      }

      // проверяем по локальному списку ошибок
      errors.forEach((err) => {
        if (err == errorMessage) {
          isNewError = false;
        }
      });

      if (isNewError) {
        errors.push(errorMessage);
      }
    });
  }

  return errors;
}

const validatePrice = (currentAtom, atom, errors) => {
  if (currentAtom.get('id') == atom.get('id')) {
    if (currentAtom.get('fixedPrice') === false) {
      errors.push('Price is set as formula');
    }
    if (!currentAtom.get('priceValue')) {
      errors.push('Price is set to 0');
    }
  } else {
    if (atom.get('fixedPrice') === false) {
      errors.push('Price is set as formula');
    }
    if (!atom.get('priceValue')) {
      errors.push('Price is set to 0');
    }
  }
};

export function validate(data,
  dealType,
  dealExpenses,
  deals,
  deal,
  expensesTypes,
  deliveryTerms,
  buyers,
  suppliers) {
  // собираем ошибки
  const estimatedErrors = [];
  const actualErrors = [];

  if (dealType
    && data
    && data.size > 0
    && deals
    && deals.size >= 3
    && expensesTypes
    && expensesTypes.size > 0
    && deliveryTerms
    && deliveryTerms.size > 0
    && buyers
    && buyers.size > 0
    && suppliers
    && suppliers.size > 0) {
    // ссылки
    const links =
      dealType == 'transport'
        ? getTLinks(data)
        : getSPLinks(data);

    if (!links || links.size == 0) {
      estimatedErrors.push('Linkage is incomplete');
      actualErrors.push('Linkage is incomplete');
      return { estimatedErrors, actualErrors };
    }

    // смотрим линки S-P
    const filteredLinks = filterLinks(links, dealType);

    if (filteredLinks && filteredLinks.size != links.size) {
      estimatedErrors.push('Linkage is incomplete');
      actualErrors.push('Linkage is incomplete');
    }

    if (filteredLinks &&
      filteredLinks.find(l => !parseFloat(l.get('quantityMax'))
       && !parseFloat(l.get('billLandingQuantity')))) {
      estimatedErrors.push('Quantity is missing');
    }

    // смотрим ошибки по B/L для this deal
    const dealErrors = validateLinks(dealType, deal, links, deals, buyers, suppliers);

    if (dealErrors && dealErrors.length > 0) {
      if (CURRENT_RELEASE >= VERSIONS.Scyleia) {
        actualErrors.push(`B/L is missing for this deal ${dealErrors.join(', ')}`);
      } else {
        actualErrors.push('B/L is missing');
      }
    }

    // смотрим ошибки по B/L для связанных сделок
    let dealInLinksErrors = [];

    links.forEach(l => {
      // id-ки S и P
      const saleId = l.get('saleId');
      const purchaseId = l.get('purchaseId');

      const saleAtom = saleId
        ? deals
          .get('sale', new List())
          .find(s => s.get('id') == saleId, this, new Map())
          .get('products', new List())
          .find((prod) => prod.get('id') == l.get('saleProduct'))
        : undefined;

      const purchaseAtom = purchaseId
        ? deals
          .get('purchase', new List())
          .find(p => p.get('id') == purchaseId, this, new Map())
          .get('products', new List())
          .find((prod) => prod.get('id') == l.get('purchaseProduct'))
        : undefined;

      if (saleAtom) {
        dealInLinksErrors =
          dealInLinksErrors.concat(
            validateLinks(
              'sale',
              undefined,
              getSPLinks(saleAtom),
              deals,
              buyers,
              suppliers,
              dealErrors));
        validatePrice(data, saleAtom, estimatedErrors);
        validatePrice(data, saleAtom, actualErrors);
      }

      if (purchaseAtom) {
        dealInLinksErrors =
          dealInLinksErrors.concat(
            validateLinks(
              'purchase',
              undefined,
              getSPLinks(purchaseAtom),
              deals,
              buyers,
              suppliers,
              dealErrors));
        validatePrice(data, purchaseAtom, estimatedErrors);
        validatePrice(data, purchaseAtom, actualErrors);
      }
    });

    if (dealInLinksErrors && dealInLinksErrors.length > 0) {
      if (CURRENT_RELEASE >= VERSIONS.Scyleia) {
        actualErrors.push(`B/L is missing for ${dealInLinksErrors.join(', ')}`);
      } else {
        if (actualErrors.filter((e) => e == 'B/L is missing').length == 0) {
          actualErrors.push('B/L is missing');
        }
      }
    }

    let actualError = null;
    let estimatedError = null;
    // перебираем все линки
    linksValidatedForFreightProcessing(
      links,
      data,
      dealType,
      deals,
      deliveryTerms,
      () => {},
      // actual errors
      (link, transport) => {
        if (CURRENT_RELEASE >= VERSIONS.Scyleia) {
          // Отображаем ошибку
          if (dealType == 'transport') {
            actualError = 'Freight is missing for this transport';
          } else {
            if (transport) {
              const transportName =
                (transport.get('vesselName')
                  ? transport.get('vesselName')
                  : ''
                )
                +
                (transport.get('voyageNumber')
                  ? ` ${transport.get('voyageNumber')}`
                  : ''
                );
              actualError = actualError || '';
              actualError += actualError
                ? `, ${transportName}`
                : `Freight is missing for ${transportName}`;
            }
          }
        } else {
          actualError = 'Freight is missing';
        }
      },
      // estimated errors
      (link, transport, leftAtom, rightAtom) => {
        if (CURRENT_RELEASE >= VERSIONS.Scyleia) {
          // атом продажи
          const saleAtom = dealType == 'sale' ? leftAtom : rightAtom;

          if (saleAtom) {
            // продажа
            const sale = deals
              .get('sale', new List())
              .find(s => s.get('id') == saleAtom.get('sale'));

            if (sale) {
              const buyer = buyers.find((b) => b.get('id') == sale.get('buyer'));
              // название S и P
              const saleName =
                getRegNumberText(
                  sale,
                  'S',
                  composeAbbrev(buyer ? buyer.get('name') : undefined),
                  'regNumber',
                  'Sale'
                );

              estimatedError = estimatedError || '';
              estimatedError += estimatedError
                ? `, ${saleName}`
                : `Freight is missing for ${saleName}`;
            }
          }
        } else {
          estimatedError = 'Freight is missing';
        }
      },
    );

    if (estimatedError) {
      estimatedErrors.push(estimatedError);
    }
    if (actualError) {
      actualErrors.push(actualError);
    }
  } // end if

  return { estimatedErrors, actualErrors };
}

export function calcFreightActual(data, dataType, transports) {
  if (dataType
    && data
    && data.size > 0
    && transports
    && transports.size > 0) {
    if (dataType == 'transport') {
      return getFreightValue(data) || 0.0;
    }
    // ссылки
    const links = getSPLinks(data);
    // проверям линки
    if (links && links.size > 0) {
      // смотрим только полные
      const fullLinks = filterFullLinks(links, dataType);

      if (fullLinks && fullLinks.size > 0) {
        // B/L quantity по полным линкам
        const blQuantity = calcBLByFullLinks(fullLinks, dataType);

        if (blQuantity > 0) {
          let freight = 0.0;
          fullLinks.forEach((l) => {
            const transport = transports.find((t) => t.get('id') == l.get('transport'));
            freight +=
              (getFreightValue(transport) || 0.0)
              * (l.get('billLandingQuantity') || 0.0);
          });
          return freight / blQuantity;
        }
      }
    }
  }
  return 0.0;
}

export function getFreight(data, dataType, transports) {
  if (dataType
    && data
    && data.size > 0
    && transports
    && transports.size > 0) {
    // ссылки
    const links =
      dataType == 'transport'
        ? getTLinks(data)
        : getSPLinks(data);
    // проверям линки
    if (links && links.size > 0) {
      const transportCount = links.map(l => l.get('transport')).toSet().size;

      const blQuantity = links.reduce((sum, l) => sum + l.get('billLandingQuantity', 0.00), 0.00);
      const failedLinks = links.filter((l) => !(l.get('billLandingQuantity') > 0));
      if (transportCount == 1) {
        let freight = 0.0;
        links.forEach((l) => {
          if (!freight) {
            const transport = transports.find((t) => t.get('id') == l.get('transport'));
            freight = blQuantity && getFreightValue(transport) ?
              getFreightValue(transport) / blQuantity : 0;
          }
        });
        return freight;
      } else if ((blQuantity > 0 && failedLinks.size == 0)) {
        let freight = 0.0;
        links.forEach((l) => {
          const transport = transports.find((t) => t.get('id') == l.get('transport'));
          freight +=
              transportCount == 1 ? getFreightValue(transport) || 0.0 :
                (getFreightValue(transport) || 0.0) * (l.get('billLandingQuantity') || 0.0);
        });
        return transportCount == 1 ? freight : freight / blQuantity;
      } return -1.0;
    }
  }
  return 0.0;
}

function excludeFreightExpenses(dealType, expenses) {
  if (!expenses) {
    return expenses;
  }
  return expenses.filter((exp) => {
    const name = getValue(exp, 'expensesTypeName');
    return !((name || '').toLowerCase() == FREIGHT_EXPENSES_TYPE && dealType == 'sale');
  });
}

export function getLinksOverallBL(atom, dealType) {
  const links = dealType == 'transport' ? getTLinks(atom) : getSPLinks(atom);
  if (links && links.size > 0) {
    return filterLinks(links, dealType).reduce((sum, l) => sum + l.get('billLandingQuantity'), 0);
  }
  return 0;
}

export function calcActualSPProfitability(atom, dealType, deals, expenses) {
  // profitability
  let profitability = 0.0;

  // сделки
  const transports = deals.get('transport');
  const sales = deals.get('sale');
  const purchases = deals.get('purchase');

  // считаем profitability
  if (atom
    && dealType
    && deals
    && transports && transports.size > 0
    && sales && sales.size > 0
    && purchases && purchases.size > 0
    && expenses) {
    // -------------------------
    // данные для расчета плюсов и минусов (S/P)
    // -------------------------

    // линки атома
    const links = getSPLinks(atom);
    const atomId = atom && atom.get('id');
    if (links && links.size > 0) {
      // берем только слинкованные сделки
      const linkedLinks = filterLinks(links, dealType);

      if (linkedLinks.size == 0) {
        return profitability;
      }

      // все ли B/L заполнены
      const blFilteredLinks = linkedLinks.filter((l) => l.get('billLandingQuantity') > 0);

      if (blFilteredLinks.size > 0) {
        // -------------------------
        // плюсы и минусы (S-P-T) overall
        // -------------------------

        let plusDAll = 0.0;
        let minusDAll = 0.0;

        let plusODAll = 0.0;
        let minusODAll = 0.0;

        let plusMinusTAll = 0.0;

        // -------------------------
        // затраты на атом
        // -------------------------
        // считаем per ton
        const actualPerTonD = calcActual(
          excludeFreightExpenses(dealType, expenses).toJS(),
          calcAtomBLCountByAllLinks(atom),
          atomId);
        // -------------------------
        // перебираем связанные линки (есть пара S-P)
        // -------------------------
        blFilteredLinks.forEach((l) => {
          // -------------------------
          // плюсы и минусы (S-P-T)

          let plusD = 0.0; // current deal
          let minusD = 0.0;

          let plusOD = 0.0; // opposite deals
          let minusOD = 0.0;

          let plusMinusT = 0.0;

          // -------------------------
          // противоположная сделка, всегда есть
          const purchaseElement = purchases
            .find((p) => p.get('id') == l.get('purchaseId'), this, new Map());
          const saleElement = sales
            .find((s) => s.get('id') == l.get('saleId'), this, new Map());
          const oppositeDealElem = dealType == 'sale' ? purchaseElement : saleElement;
          const thisDealElement = dealType == 'purchase' ? purchaseElement : saleElement;

          const thisDealName = `#${thisDealElement.get(dealType == 'sale' ?
            'buyer' : 'supplier', '')}#${thisDealElement.get('regNumber') || ''}`;


          const oppositeDealAtom = dealType == 'sale'
            ? oppositeDealElem
              .get('products', new List())
              .find((prod) => prod.get('id') == l.get('purchaseProduct'))
            : oppositeDealElem
              .get('products', new List())
              .find((prod) => prod.get('id') == l.get('saleProduct'));

          if (oppositeDealAtom) {
            const oppositeDealName = `#${oppositeDealElem.get(dealType != 'sale' ?
              'buyer' : 'supplier', '')}#${oppositeDealElem.get('regNumber') || ''}`;
            // проверяем наличие Lump Sum
            const oppositeDeal = dealType == 'sale' ? 'purchase' : 'sale';
            const oppositeAtomExpenses =
              excludeFreightExpenses(
                oppositeDeal,
                getExpenses(oppositeDealAtom, oppositeDeal));

            calcActual(
              excludeFreightExpenses(dealType, expenses).toJS(),
              calcAtomBLCountByAllLinks(atom),
              atomId,
              [`${l.get('id')}#${l.get('transport')}`, `${dealType}${thisDealName}`], l
            );

            // -------------------------
            // Purchase/Sale (opposite atom)
            // -------------------------
            // считаем per ton
            const actualPerTon = calcActual(
              oppositeAtomExpenses.toJS(),
              calcAtomBLCountByAllLinks(oppositeDealAtom),
              atomId,
              [`${l.get('id')}#${l.get('transport')}`, `${oppositeDeal}${oppositeDealName}`], l
            );

            // цена
            let price = getPriceValue(oppositeDealAtom) || 0.0;
            const lsPrice = price * (l.get('billLandingQuantity') || 0);
            if (dealType == 'sale') {
              plusOD = 0.0;
              minusOD = lsPrice +
                actualPerTon * (l.get('billLandingQuantity') || 0);
              putPLRow(store.dispatch,
                `Purchase price#${getValue(oppositeDealAtom, 'id')}`,
                { pt: price * -1, estimatedPt: price * -1, bl: l.get('billLandingQuantity') },
                atomId,
                [`${l.get('id')}#${l.get('transport')}`, `${oppositeDeal}${oppositeDealName}`]);
            } else {
              plusOD = lsPrice;
              minusOD = (l.get('billLandingQuantity') || 0) * actualPerTon;
              putPLRow(store.dispatch,
                `Sale price#${getValue(oppositeDealAtom, 'id')}`,
                { pt: price, estimatedPt: price, bl: l.get('billLandingQuantity') },
                atomId,
                [`${l.get('id')}#${l.get('transport')}`, `${oppositeDeal}${oppositeDealName}`]);
            }

            plusODAll += plusOD;
            minusODAll += minusOD;


            // -------------------------
            // Transport
            // -------------------------

            const transport = transports.find((t) => t.get('id') == l.get('transport'));

            if (transport) {
              const transportExpenses =
                excludeFreightExpenses('transport', getExpenses(transport, 'transport'));

              // считаем per ton
              const actualPerTonT =
                calcActual(
                  transportExpenses.toJS(),
                  calcTransportBLCountByAllLinks(transport),
                  atomId,
                  [`${l.get('id')}#${l.get('transport')}`, 'transport'], l
                );
              plusMinusT +=
                -(l.get('billLandingQuantity') || 0) * actualPerTonT;

              // Freight c транспорта, если он задан
              const freightValue = getFreightValue(transport) || 0.0;
              const lsFreight = -(l.get('billLandingQuantity') || 0)
              * freightValue;
              plusMinusT += lsFreight;
              putPLRow(store.dispatch,
                'Transport freight#',
                { pt: freightValue * -1, bl: l.get('billLandingQuantity') },
                atomId,
                [`${l.get('id')}#${l.get('transport')}`, 'transport']);

              plusMinusTAll += plusMinusT;
            }

            // -------------------------
            // Sale/Purchase (current deal)
            // -------------------------

            // цена
            price = getPriceValue(atom) || 0.0;

            const dealPrice = price * (l.get('billLandingQuantity') || 0.0);
            if (dealType == 'sale') {
              plusD = dealPrice;
              minusD = (l.get('billLandingQuantity') || 0) * actualPerTonD;
              putPLRow(store.dispatch, `Sale price#${atomId}`,
                { pt: price, estimatedPt: price, bl: l.get('billLandingQuantity') },
                atomId, [`${l.get('id')}#${l.get('transport')}`, `${dealType}${thisDealName}`]);
            } else {
              putPLRow(store.dispatch, `Purchase price#${atomId}`,
                { pt: price * -1, estimatedPt: price * -1, bl: l.get('billLandingQuantity') },
                atomId, [`${l.get('id')}#${l.get('transport')}`, `${dealType}${thisDealName}`]);
              plusD = 0.0;
              minusD = dealPrice +
                actualPerTonD * (l.get('billLandingQuantity') || 0);
            }

            plusDAll += plusD;
            minusDAll += minusD;
          }
        }); // end of link's forEach

        const blQuantitySum = calcAtomBLCountByFullLinks(atom, dealType);
        if (blQuantitySum) {
          // Общая прибыльность каждого атома
          profitability =
            (plusDAll - minusDAll
            + plusODAll - minusODAll
            + plusMinusTAll) / blQuantitySum;
        }
      }
    }
  }
  return profitability;
}

export function calcActualTProfitability(deal, deals, expenses) {
  let profitability = 0.0;
  // считаем profitability только для S
  if (deal
      && deals
      && deals.get('sale') && deals.get('sale').size > 0
      && deals.get('purchase') && deals.get('purchase').size > 0) {
    // сделки
    const sales = deals.get('sale');
    const purchases = deals.get('purchase');

    // получаем линки транспорта
    const links = getTLinks(deal);

    if (links && links.size > 0) {
      // берем только слинкованные сделки
      const linkedLinks = filterLinks(links, 'transport');
      if (linkedLinks.size == 0) {
        return profitability;
      }

      // все ли B/L заполнены
      const blFilteredLinks = linkedLinks.filter((l) => l.get('billLandingQuantity') > 0);

      if (linkedLinks.size == blFilteredLinks.size) {
        // -------------------------
        // плюсы и минусы (S-P-T) overall
        // -------------------------

        let plusSAll = 0.0;
        let minusSAll = 0.0;

        let plusPAll = 0.0;
        let minusPAll = 0.0;

        let plusMinusTAll = 0.0;

        // -------------------------
        // данные для расчета плюсов и минусов (T)
        // -------------------------
        // считаем per ton
        const actualPerTonT =
          calcActual(
            excludeFreightExpenses('transport', expenses).toJS(),
            calcTransportBLCountByAllLinks(deal),
            deal.get('id')
          );

        // -------------------------
        // перебираем связанные линки (есть пара S-P)
        // -------------------------

        blFilteredLinks.forEach((l) => {
          // -------------------------
          // плюсы и минусы (S-P-T)

          let plusS = 0.0;
          let minusS = 0.0;

          let plusP = 0.0;
          let minusP = 0.0;

          let plusMinusT = 0.0;

          // -------------------------

          // связанный атом P
          const purchaseElement = purchases
            .find((p) => p.get('id') == l.get('purchaseId'), this, new Map());
          const saleElement = sales
            .find((s) => s.get('id') == l.get('saleId'), this, new Map());


          const purchaseDealName = `Purchase#${purchaseElement.get('supplier', '')}#${
            purchaseElement.get('regNumber') || ''}`;
          const saleDealName = `Sale#${saleElement.get('supplier', '')}#${
            saleElement.get('regNumber') || ''}`;

          const purchaseAtom = purchaseElement
            .get('products', new List())
            .find((prod) => prod.get('id') == l.get('purchaseProduct'));
          // связанный атом S
          const saleAtom = saleElement
            .get('products', new List())
            .find((prod) => prod.get('id') == l.get('saleProduct'));

          if (purchaseAtom && saleAtom) {
            // проверяем наличие Lump Sum
            const saleAtomExpenses =
              excludeFreightExpenses('sale', getExpenses(saleAtom, 'sale'));
            const purchaseAtomExpenses =
              excludeFreightExpenses('purchase', getExpenses(purchaseAtom, 'purchase'));

            // -------------------------
            // Sale
            // -------------------------

            // считаем per ton
            const actualPerTonS = calcActual(
              saleAtomExpenses.toJS(),
              calcAtomBLCountByAllLinks(saleAtom, l),
              deal.get('id'),
              [`${l.get('id')}#${l.get('transport')}`, saleDealName], l
            );

            // цена
            const priceS = getPriceValue(saleAtom) || 0.0;
            putPLRow(store.dispatch,
              `Sale price#${getValue(saleAtom, 'id')}`,
              { pt: priceS, estimatedPt: priceS, bl: l.get('billLandingQuantity') }, deal.get('id'),
              [`${l.get('id')}#${l.get('transport')}`, saleDealName]);
            plusS = priceS * (l.get('billLandingQuantity') || 0);
            minusS = actualPerTonS * (l.get('billLandingQuantity') || 0);

            plusSAll += plusS;
            minusSAll += minusS;

            // -------------------------
            // Purchase
            // -------------------------

            // считаем per ton
            const actualPerTonP = calcActual(
              purchaseAtomExpenses.toJS(),
              calcAtomBLCountByAllLinks(purchaseAtom, l),
              deal.get('id'),
              [`${l.get('id')}#${l.get('transport')}`, purchaseDealName], l
            );

            calcActual(
              excludeFreightExpenses('transport', expenses).toJS(),
              calcTransportBLCountByAllLinks(deal),
              deal.get('id'),
              [`${l.get('id')}#${l.get('transport')}`, 'Transport'], l
            );
            // цена
            const priceP = getPriceValue(purchaseAtom) || 0.0;
            putPLRow(store.dispatch,
              `Purchase price#${getValue(purchaseAtom, 'id')}`,
              { pt: priceP * -1, estimatedPt: priceP * -1, bl: l.get('billLandingQuantity') },
              deal.get('id'),
              [`${l.get('id')}#${l.get('transport')}`, purchaseDealName]);

            plusP = 0.0;
            minusP = priceP * (l.get('billLandingQuantity') || 0.0) +
              actualPerTonP * (l.get('billLandingQuantity') || 0.0);

            plusPAll += plusP;
            minusPAll += minusP;

            // -------------------------
            // Transport
            // -------------------------

            plusMinusT += -(l.get('billLandingQuantity') || 0) * actualPerTonT;

            plusMinusTAll += plusMinusT;
          }
        }); // end of link's forEach

        const blQuantitySum = calcTransportBLCountByFullLinks(deal, 'transport');

        if (blQuantitySum) {
          // общая прибыльность транспорта
          profitability =
            (plusSAll - minusSAll
            + plusPAll - minusPAll
            + plusMinusTAll) / blQuantitySum;
        }
      }
    }
  }
  return profitability;
}

const setEstimatedFreight = (expenses, actualFreight) => {
  if (!expenses) {
    return [];
  }
  let expensesJS = expenses.toJS ? expenses.toJS() : expenses;
  expensesJS = expensesJS.map((e) => {
    const name = getValue(e, 'expensesTypeName');
    if (name && name.toLowerCase() == FREIGHT_EXPENSES_TYPE && !e.estimate) {
      return { ...e, estimate: actualFreight };
    }
    return e;
  });
  return expensesJS;
};

export function calcEstimatedSPProfitability(
  atom,
  dealType,
  deals,
  deliveryTerms,
  expenses,
  transportExpenses,
  filterLink) {
  // profitability
  let profitability = 0.0;

  // считаем profitability
  if (atom && dealType
    && deals && deals.size > 0
    && deliveryTerms && deliveryTerms.size > 0
    && expenses) {
    // линки атома
    let links = getSPLinks(atom);
    const atomId = atom.get('id');
    links = (links && links.size > 0 && filterLink)
      ? links.filter((l) => l.get('id') == filterLink.get('id'))
      : links;

    if (links && links.size > 0) {
      // считаем количество (общее слинкованное)
      let totalQuantity = 0;

      // -------------------------
      // плюсы и минусы (S-P-T) overall
      // -------------------------

      let plusMinusSAll = 0.0;

      let plusMinusPAll = 0.0;

      let plusMinusTAll = 0.0;

      // -------------------------

      linksValidatedForFreightProcessing(
        links,
        atom,
        dealType,
        deals,
        deliveryTerms,
        (link, transport, leftAtom, rightAtom) => {
          // quantity на линке
          const lq = link.get('billLandingQuantity') || getQuantity(link);
          totalQuantity += lq;
          let finalTransportExpenses;
          let actualFreight = 0;
          if (transport) {
            actualFreight = getFreightValue(transport) || 0.0;
            finalTransportExpenses = transportExpenses
              ? transportExpenses.toJS() : getExpensesJS(transport, 'transport');
          } else {
            finalTransportExpenses = transportExpenses
              ? transportExpenses.toJS() : [];
          }
          plusMinusTAll -= lq *
            calcEstimated(finalTransportExpenses,
              atomId,
              [`${link.get('id')}#${link.get('transport')}`, 'transport']
            );
          if (dealType == 'transport') {
            // purchase
            const priceP = getPriceValue(leftAtom) || 0.0;
            const expensesP = calcEstimated(getExpensesJS(leftAtom, 'purchase'),
              atomId,
              [`${link.get('id')}#${link.get('transport')}`, 'purchase']);
            plusMinusPAll += (-priceP - expensesP) * lq;
            // sale
            const priceS = getPriceValue(rightAtom) || 0.0;
            const expensesS = calcEstimated(getExpensesJS(rightAtom, 'sale'),
              atomId,
              [`${link.get('id')}#${link.get('transport')}`, 'sale']);
            plusMinusSAll += (priceS - expensesS) * lq;
          }
          if (dealType == 'purchase') {
            // sale (берем противоположный атом)
            const priceS = getPriceValue(rightAtom) || 0.0;
            const expensesS = calcEstimated(
              setEstimatedFreight(getExpensesJS(rightAtom), actualFreight),
              atomId,
              [`${link.get('id')}#${link.get('transport')}`, 'sale']);
            plusMinusSAll += (priceS - expensesS) * lq;
            // purchase (берем текущий атом)
            const priceP = getPriceValue(leftAtom) || 0.0;
            const expensesP = calcEstimated(expenses.toJS(),
              atomId,
              [`${link.get('id')}#${link.get('transport')}`, 'This purchase']);
            plusMinusPAll += (-priceP - expensesP) * lq;
          }
          if (dealType == 'sale') {
            // purchase (берем противоположный атом)
            const priceP = getPriceValue(rightAtom) || 0.0;
            const expensesP = calcEstimated(getExpensesJS(rightAtom, 'sale'),
              atomId,
              [`${link.get('id')}#${link.get('transport')}`, 'purchase']);
            plusMinusPAll += (-priceP - expensesP) * lq;
            // sale (берем текущий атом)
            const priceS = getPriceValue(leftAtom) || 0.0;
            const expensesS = calcEstimated(setEstimatedFreight(expenses, actualFreight),
              atomId,
              [`${link.get('id')}#${link.get('transport')}`, 'This sale']);
            plusMinusSAll += (priceS - expensesS) * lq;
          }
        });

      // -------------------------
      // profitability атома
      // -------------------------

      if (totalQuantity > 0) {
        profitability = (plusMinusPAll + plusMinusSAll + plusMinusTAll) / totalQuantity;
      }
    }
  }

  return profitability;
}

export function calcEstimatedTProfitability(deal, dealType, deals, deliveryTerms, expenses) {
  // profitability
  let profitability = 0.0;

  // считаем profitability
  if (deal && dealType
    && deals && deals.size > 0
    && deliveryTerms && deliveryTerms.size > 0
    && expenses) {
    // считаем количество (общее слинкованное)
    let totalQuantity = 0;

    const links = getTLinks(deal);

    linksValidatedForFreightProcessing(
      links,
      deal,
      dealType,
      deals,
      deliveryTerms,
      (link, transport, leftAtom) => {
        // общее количество на линке
        const lq = link.get('billLandingQuantity') || getQuantity(link);
        totalQuantity += lq;
        // считаем по одному атому, т.к. второй атом даст аналогичный рассчет
        const atomProfitability =
          calcEstimatedSPProfitability(
            leftAtom,
            'purchase',
            deals,
            deliveryTerms,
            getExpenses(leftAtom, 'purchase'),
            expenses,
            link);

        profitability += atomProfitability * lq;
      }
    );
    // -------------------------
    // profitability транспорта
    // -------------------------
    if (totalQuantity > 0) {
      profitability = profitability / totalQuantity;
    }
  }

  return profitability;
}
